<!--------------------------->
<!-- Panel SignDestination -->
<!--------------------------->
<div>
    <div class="row">
        <div class="form-group col-12 pb-3" *ngFor="let currSign of signList">
            <div *ngIf="currSign.type != 'driverStamp'">
                <br>
                <h6 for="signature">{{ 'sign.' +  currSign.type + '_sign' | translate }}</h6>
                <hr>
                <!-- Campo de consignee Name -->
                <div class="aclaration-field">
                    <!-- <span class="required-field" *ngIf="currSign.isRequiredPrintName && !(currSign.printName)">*</span> -->
                    <input #signAclaration="ngModel" 
                        [disabled]='false'
                        [ngClass]="{'alert-border': signAclaration.invalid && signAclaration.touched}"
                        [required]="currSign.isRequiredPrintName" type="text" 
                        [(ngModel)]="currSign.printName"
                        maxlength="40" 
                        [ngModelOptions]="{standalone: true}"
                        placeholder="{{'sign.' +  currSign.type + '_type_ph' | translate}}"
                        class="print-name-input form-control w-50">
                </div>
                <br>
                <!-- Campo de modal de firma -->
                <div id="signature" 
                class="signature"
                (click)="currSign.printName ? createSign(content, currSign.type) : showAlert()">
                    <input type="text" 
                    [hidden]="true" 
                    [ngModel]="currSign.sign"
                    [ngModelOptions]="{standalone: true}" 
                    [required]="currSign.isRequiredSign">
                    <img *ngIf="currSign.sign" class="sign-image" src="{{currSign.sign}}" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<!---------------------------->
<!-- Ventana modal de firma -->
<!---------------------------->
<ng-template #content let-modal>
    <div class="modal-header">
        <h4 *ngIf="!signed" class="modal-title" id="modal-basic-title">{{'sign.signature_pad_title' | translate}}</h4>
        <h4 *ngIf="signed" class="modal-title" id="modal-basic-title">Successfully Signed!</h4>
        <button type="button" class="btn ms-auto close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p *ngIf="signed">Ready for the next steps!</p>
        <app-signature-pad *ngIf="!signed" (sendSign)="getSign($event)" [modal]="modal" [currentSign]="currentSign"
            [withUpload]="mockAuthService.hasSigners()" [driverView]= "true">
        </app-signature-pad>
    </div>
    <div *ngIf="signed" class="modal-footer">
        <button type="button" class="btn btn-success" (click)="closeModal()">Accept</button>
    </div>
</ng-template>
